import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthGuardService, AuthService } from 'src/app/services';
import {
  LicenseTypeEnum,
  UserDutyEnum
} from 'src/enumerators';
import { AuthorizationService } from './../../services/authorization.service';
import { RbacService } from 'src/app/services/rbac.service';

@Component({
  selector: 'app-header-menu',
  templateUrl: './header-menu.component.html',
  styleUrls: ['./header-menu.component.css'],
})
export class HeaderMenuComponent implements OnInit {
  router;
  userDutyEnum = UserDutyEnum;
  licenseTypeEnum = LicenseTypeEnum;
  calcWidth = '';

  constructor(
    private _router: Router,
    public auth: AuthService,
    public authorizationService: AuthorizationService,
    private _authGuard: AuthGuardService,
    private _rbac: RbacService,
  ) { }

  ngOnInit(): void {
    this.auth.memberSub.asObservable().subscribe(next => {
      if (!next) return
      this.router = this._rbac.can('projects', 'read') ? '/projects' : '/paths';

      if (this._router.url.includes('/projects') || this._router.url.includes('/region-area') || this._router.url.includes('/paths') || this._router.url.includes('/stock')) {
        this.router = this._router.url;
      }
    })

  }
}
